/** @jsxRuntime classic */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import /* webpackPrefetch: true */ './assets/fonts/4e93482e-40f7-4349-a9c2-f8882f15a93b.woff';
import /* webpackPrefetch: true */ './assets/fonts/ce398c7a-fb54-4409-89f7-241065e2af3d.woff';
import /* webpackPrefetch: true */ './assets/fonts/e13304eb-e376-4603-a460-2da742ef32c7.woff';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Root from './components/Root';
import AuthenticationContainer from './containers/Authentication/AuthenticationContainer';
import { withMaybeFragment } from './hoc/withMaybeFragment';
import store from './redux/store/store';
import { isMocks } from './utils/utils';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import './assets/css/grid12.css';

// Maybe wrap our component with AuthenticationContainer
const MaybeAuthenticationContainer = withMaybeFragment(AuthenticationContainer);
const rootElement = document.getElementById('react-app-hook');
const query = window.location.search.substring(1);
const vars = query.split('&');
for (let i = 0; i < vars.length; i++) {
  const pair = vars[i].split('=');
  if (decodeURIComponent(pair[0]) === 'RepGroupId') {
    document.cookie = `salesForceDept=${decodeURIComponent(pair[1])}`;
  }
}
const renderedRoot = (
  <Provider store={store}>
    {/* AuthenticationContainer does not expect or use [store] */}
    <MaybeAuthenticationContainer shouldShowFragment={isMocks()}>
      <ErrorBoundary>
        <Root />
      </ErrorBoundary>
    </MaybeAuthenticationContainer>
  </Provider>
);

if (rootElement) {
  ReactDOM.render(renderedRoot, rootElement);
} else {
  throw Error('HTML page is missing the required base element');
}
